import React from 'react';
import { Lock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const PlanGate = ({ requiredPlan, currentPlan, subscriptionActive = true, children }) => {
  const navigate = useNavigate();

  const planHierarchy = {
    'No plan': 0,
    'Beginner': 1, 'Pro': 2, 'Unlimited': 3,
    'MSP_Beginner': 1, 'MSP_Pro': 2, 'MSP_Unlimited': 3,
    'MIP_Beginner': 1, 'MIP_Pro': 2, 'MIP_Unlimited': 3,
  };

  // Strip prefix to get the base tier level
  const getLevel = (plan) => planHierarchy[plan] ?? 0;

  // Detect which product the route requires based on requiredPlan prefix
  const routeIsMSP = requiredPlan.startsWith('MSP_');
  const routeIsMIP = requiredPlan.startsWith('MIP_');
  const requiredLevel = getLevel(requiredPlan.replace('MSP_', '').replace('MIP_', ''));

  // Detect what product the user has
  const userIsMSP = currentPlan.startsWith('MSP_');
  const userIsMIP = currentPlan.startsWith('MIP_');
  const userIsBundle = !userIsMSP && !userIsMIP && currentPlan !== 'No plan';

  // Bundle can access everything
  // MSP can only access MSP routes
  // MIP can only access MIP routes
  const productMatch = userIsBundle
    || (routeIsMSP && userIsMSP)
    || (routeIsMIP && userIsMIP)
    || (!routeIsMSP && !routeIsMIP && (userIsBundle || userIsMSP || userIsMIP)); // no prefix = legacy, allow all

  const hasAccess = subscriptionActive && productMatch && getLevel(currentPlan) >= requiredLevel;

  if (hasAccess) {
    return children;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 flex items-center justify-center p-4 -mt-20">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full text-center">
        <div className="w-20 h-20 bg-gradient-to-r from-orange-500 to-red-600 rounded-full flex items-center justify-center mx-auto mb-6">
          <Lock className="text-white" size={40} />
        </div>

        <h2 className="text-3xl font-bold text-gray-900 mb-4">
          {!subscriptionActive ? 'Subscription Inactive' : `${requiredPlan.replace("_", " ")} Plan Required`}
        </h2>

        <p className="text-gray-600 mb-6">
          {!subscriptionActive
            ? 'No active subscription. Subscribe to access this feature.'
            : `This feature requires the ${requiredPlan.replace("_", " ")} plan or higher.`
          }
        </p>

        <div className="bg-gray-50 rounded-lg p-4 mb-6">
          <p className="text-sm text-gray-700">
            <span className="font-semibold">Your Current Plan:</span> {currentPlan.replace("_", " ")}
            {!subscriptionActive && ' (Inactive)'}
          </p>
        </div>

        <button
          onClick={() => navigate('/pricing')}
          className="w-full bg-gradient-to-r from-teal-500 to-blue-600 text-white py-3 rounded-lg font-semibold hover:opacity-90 transition shadow-lg"
        >
          {!subscriptionActive ? 'Renew Subscription' : `Upgrade to ${requiredPlan.replace("_", " ")} Plan`}
        </button>

        <button
          onClick={() => navigate('/dashboard')}
          className="w-full mt-3 border-2 border-gray-300 text-gray-700 py-3 rounded-lg font-semibold hover:bg-gray-50"
        >
          Back to Dashboard
        </button>
      </div>
    </div>
  );
};

export default PlanGate;